module.exports = __webpack_public_path__ + "assets/img/icon2.409aebe8.png";